import { render, staticRenderFns } from "./OrderItemNoteEditForm.vue?vue&type=template&id=d71701e4"
import script from "./OrderItemNoteEditForm.vue?vue&type=script&lang=js"
export * from "./OrderItemNoteEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports